import { DropdownModel } from "./../../report/models/report-filter.model";
import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import {
  IKeyValueInterface,
  IAPIResponse,
  ApplicationRouteURL,
  WeGoConfig
} from "../../shared/config";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import { AdminInvitationService } from "../models/admin-invitation.service";
import { AdminInvitationProfileModel } from "../models/admin-invitation.model";
import { fail } from "assert";
import { TermsConditionPopup } from "../../termsconditionpopup/models/terms-condition-popup.service";
import { PrivacyStatementPopup } from "../../privacypopup/models/privacy-popup.service";
import {
  TermsConditionModel,
  TermsConditionStatus
} from "../../termsandcondition/models/terms-condition.model";

declare var RemoveBranding: any;
declare var ChangeBranding: any;

@Component({
  selector: "wego-admin-invitation",
  template: require('../views/admin-invitation.component.html'),
  providers: [
    AdminInvitationService,
    TermsConditionPopup,
    PrivacyStatementPopup
  ],
  styles: [
    `.main-header {
        margin-top:0px !important;
      }
      .input-group.telephone-group .input-group-addon {
        padding: 0px;
        border: 0px;
      }
      .country-select {
        width: 60px;
        border: 1px solid #d2d6de;
        padding: 3px;
      }
    `
  ]
})
export class AdminInvitationComponent implements OnInit, OnDestroy {
  isDriver: boolean;

  allTNCList: TermsConditionStatus[] = [];

  isBodyContent: boolean = false;
  isPrivacyBodyContent: boolean = false;

  bodyHTMLText: string;
  privacyBodyHTMLText: string;

  activationCode: string;
  rejectionCode: string;
  sub: any;
  submitted = false;
  isLoading: boolean;
  isPageLoad: boolean = false;
  model: AdminInvitationProfileModel;
  errorModel: IKeyValueInterface[];
  message: string;
  errorMessage: string;
  popupMsg: string;
  popupTitle: string;
  flatPickrConfigDateOfBirth: FlatPickrModel;
  dateFormat: string = WeGoConfig.FLATPICKR_DATE_FORMAT;

  termsAndConditionHashId: string;
  privacyHashId: any;
  countryList: DropdownModel[];

  @ViewChild("errorSuccessPopup") public errorSuccessPopup: any;
  @ViewChild("termsConditionModel") public termsConditionModel: any;
  @ViewChild("privayStatementModel") public privacyModel: any;

  constructor(
    private adminInvitationService: AdminInvitationService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private termsConditionPopup: TermsConditionPopup,
    private privacyPopup: PrivacyStatementPopup
  ) {}

  ngOnInit() {
    this.isPageLoad = false;
    this.isLoading = true;
    this.translate.setDetectedLang();
    this.popupTitle = this.translate.instant("LblError");
    this.popupMsg = this.translate.instant("LblCommonErrorMessage");
    this.flatPickrConfigDateOfBirth = this.SetDefaultFlatPickrConfig();
    this.model = new AdminInvitationProfileModel();
    this.GetTelephoneCountry();
    this.sub = this.activeRoute.params.subscribe(params => {
      this.activationCode = params["activationCode"] || "";
      this.rejectionCode = params["rejectionCode"] || "";
      if (this.activationCode != "") {
        this.adminInvitationService
          .CheckActivationCodeIsValid(this.activationCode)
          .subscribe(
            res => {
              if (res.data) {
                this.adminInvitationService
                  .CheckPersonExistByActivationCode(this.activationCode)
                  .subscribe(
                    res => {
                      if (res.data != null) {
                        this.model.countryCode1 = res.data.countryCode;
                        this.model.countryCode2 = res.data.countryCode;
                        if (res.data.status == "Found") {
                          this.adminInvitationService
                            .CheckPersonRoleExistByActivationCode(
                              this.activationCode
                            )
                            .subscribe(
                              res => {
                                if (res.data) {
                                  this.adminInvitationService
                                    .InvitationAccepted(this.activationCode)
                                    .subscribe(
                                      res => {
                                        if (res.data) {
                                          this.router.navigate([
                                            "/invitationaccept"
                                          ]);
                                        } else {
                                          this.router.navigate([
                                            "/Linkexpired"
                                          ]);
                                        }
                                        this.isPageLoad = true;
                                        this.isLoading = false;
                                      },
                                      error => {
                                        this.errorMessage = this.authService.HandleErrorStatusCode(
                                          error
                                        );
                                        this.message = <any>error;
                                        this.HandleError();
                                      }
                                    );
                                } else {
                                  this.router.navigate([
                                    "/personprofile",
                                    {
                                      activationCode: this.activationCode
                                    }
                                  ]);
                                }
                              },
                              error => {
                                this.errorMessage = this.authService.HandleErrorStatusCode(
                                  error
                                );
                                this.message = <any>error;
                                this.HandleError();
                              }
                            );
                        } else {
                          this.model.emailAddressModel.email = res.data.email;
                          this.model.validateLiceanceNumber =
                            res.data.licenceRequired;
                          this.isDriver = res.data.isDriver;
                          this.isPageLoad = true;
                          ChangeBranding("", "", this.activationCode);
                          this.isLoading = false;
                        }
                      }
                    },
                    error => {
                      this.errorMessage = this.authService.HandleErrorStatusCode(
                        error
                      );
                      this.message = <any>error;
                      this.HandleError();
                    }
                  );
              } else {
                this.router.navigate(["/Linkexpired"]);
                this.isPageLoad = true;
                this.isLoading = false;
              }
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
              this.message = <any>error;
              this.HandleError();
            }
          );
      } else if (this.rejectionCode != "") {
        this.adminInvitationService
          .InvitationRejected(this.rejectionCode)
          .subscribe(
            res => {
              if (res.data) {
                this.router.navigate(["/invitationreject"]);
              } else {
                this.router.navigate(["/Linkexpired"]);
              }
              this.isPageLoad = true;
              this.isLoading = false;
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
              this.message = <any>error;
              this.HandleError();
            }
          );
      }
    });
    this.GetTermsConditionByActivationCode(this.activationCode);
    this.GetPrivacyByPersonActivationCode(this.activationCode);
  }
  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.time_24hr = false;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    flatPickrConfig.maxDate = new Date();
    return flatPickrConfig;
  }

  public HandleError() {
    this.isPageLoad = true;
    this.isLoading = false;
    this.ShowSuccessPopup();
  }

  onSubmit(forms: any) {
    this.submitted = true;
    this.model.approvalCode = this.activationCode;
    this.model.isDriver = this.isDriver;
    this.AddPersonProfile();
  }

  public AddPersonProfile() {
    this.isLoading = true;
    this.model.termsAndConditionsHashId = this.termsAndConditionHashId;
    this.model.privacyHashId = this.privacyHashId;
    this.model.allTermsConditionsList = this.allTNCList;
    this.adminInvitationService.AddPersonProfile(this.model).subscribe(
      res => {
        if (res.data) {
          //ChangeBranding();
          this.router.navigate(["/"]);
        } else {
          this.errorModel = res.error;
        }
        this.isLoading = false;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
        this.ShowSuccessPopup();
      }
    );
  }

  public GetTelephoneCountry() {
    this.authService.GetTelephoneCountry().subscribe(
      res => {
        this.countryList = res.data;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public showTnC(bodyHTMLText: string) {
    this.termsConditionModel.show(bodyHTMLText);
  }

  public showPrivacyStatement() {
    this.privacyModel.show(this.privacyBodyHTMLText);
  }

  public ShowSuccessPopup(): void {
    this.errorSuccessPopup.show();
  }

  public HideSuccessPopup(): void {
    this.errorSuccessPopup.hide();
    this.RedirectToHomePage();
  }

  public ConfirmSuccessPopup(): void {
    this.errorSuccessPopup.hide();
    this.RedirectToHomePage();
  }

  public RedirectToHomePage(): void {
    this.router.navigate(["/"]);
  }

  public SuccessModalClick(): void {
    this.termsConditionModel.hide();
  }

  public GetTermsConditionByActivationCode(activationCode: string) {
    this.termsConditionPopup
      .GetTermsAndConditionsByActivationCode(activationCode)
      .subscribe(
        res => {
          if (res.data) {
            this.allTNCList = res.data;
            // this.bodyHTMLText = res.data.content;
            // if (res.data.content) {
            //   this.isBodyContent = true;
            // }
            // this.termsAndConditionHashId = res.data.termsAndConditionsHashId;
          } else {
            this.errorMessage = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetPrivacyByPersonActivationCode(activationCode: string) {
    this.termsConditionPopup
      .GetPrivacyStatementsByActivationCode(activationCode)
      .subscribe(
        res => {
          if (res.data && res.data.content) {
            this.privacyBodyHTMLText = res.data.content;
            if (res.data.content) {
              this.isPrivacyBodyContent = true;
            }
            this.privacyHashId = res.data.termsAndConditionsHashId;
          } else {
            this.errorMessage = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  ngOnDestroy() {
    ChangeBranding();
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-invitation/components/admin-invitation.component.ts